import {
  USER_LOGIN,
  USER_LOGOUT,
  CLEAR_USER_LOGGED,

  GET_USERINFO,
  UPDATE_USERINFO,
  GET_VIP_INFORMATION,

  UPDATE_USER_AVATAR,
  UNBIND_WECHAT,
  UPDATE_WECHAT_DATA,

  GET_MY_INVOICE,
  SUBMIT_AN_INVOICE,

  UPDATE_VIP_ROLE,

  UPDATE_COMPARE_IDS,
  CHANGE_USER_INFO

} from '../mutiation'
import _ from 'lodash'
import moment from 'moment'

// initial state
// shape: [{ id, quantity }]
const setFocusIndustryList = (focusIndustryList) => {
  return focusIndustryList.length ? focusIndustryList : ['消费']
}
const setFocusCategoryList = (focusCategoryList) => {
  return focusCategoryList.length ? focusCategoryList : ['生产风险']
}
const state = {
  username: localStorage.getItem('access_username') || '',
  uid: localStorage.getItem('access_uid') || '',
  roleId: +localStorage.getItem('access_roleId') || 0,
  token: localStorage.getItem('access_token') || '',
  headUrl: localStorage.getItem('access_img') || '/static/avatar.png',
  // headUrl: (localStorage.getItem('access_img').indexOf('http') === 0 ? localStorage.getItem('access_img') : `/app/${localStorage.getItem('access_img')}`) || '/static/avatar.png',
  // vip: localStorage.getItem('access_vip') === 'true',
  userinfo: {
    name: localStorage.getItem('access_username') || '',
    phone: '',
    isVip: localStorage.getItem('access_vip') || false,
    roleId: localStorage.getItem('access_role') || 0,
    headUrl: localStorage.getItem('access_img') || '/static/avatar.png',
    focusIndustryList: [],
    focusCategoryList: []
  },
  vipinfo: {},
  compareIds: []
}

// actions
const actions = {

}

// mutations
const mutations = {
  [CHANGE_USER_INFO] (state, userinfo) {
    const { focusIndustryList, focusCategoryList } = userinfo
    state.userinfo = Object.assign({}, userinfo, {
      focusIndustryList: setFocusIndustryList(focusIndustryList),
      focusCategoryList: setFocusCategoryList(focusCategoryList)
    })
  },
  [USER_LOGIN] (state, data) {
    this.commit('CHANGE_USER_INFO', {
      name: data.user.userName,
      isVip: +data.user.roleId !== 0,
      roleId: +data.user.roleId,
      role: data.user.role,
      focusIndustryList: data.user.focusIndustryList,
      focusCategoryList: data.user.focusCategoryList
    })
    state.token = data.user.token
    // state = Object.assign(state, data.user, {
    //   vip: true
    // })
  },
  [USER_LOGOUT] (state, data) {
    state.userinfo = {}
    state.vipinfo = {}
    state.username = ''
    state.uid = ''
    state.roleId = ''
    state.token = ''
    state.headUrl = localStorage.getItem('access_img') || '/static/avatar.png'
    state.vip = ''
  },
  [UPDATE_VIP_ROLE] (state, data) {
    state.roleId = 1
    localStorage.setItem('access_roleId', 1)
  },
  [GET_USERINFO] (state, data) {
    this.commit('CHANGE_USER_INFO', Object.assign({}, data.userinfo, {
      headUrl: data.userinfo.headUrl && data.userinfo.headUrl.indexOf('http') === 0 ? data.userinfo.headUrl : '/app/' + data.userinfo.headUrl
    }))
  },
  [UPDATE_USERINFO] (state, data) {
    // console.log(data.userinfo)
    let headUrl = {}
    if (data.userinfo.headUrl) {
      headUrl = {
        headUrl: data.userinfo.headUrl && data.userinfo.headUrl.indexOf('http') === 0 ? data.userinfo.headUrl : '/app/' + data.userinfo.headUrl
      }
    }
    Object.assign({}, data.userinfo, {
      headUrl: data.userinfo.headUrl && data.userinfo.headUrl.indexOf('http') === 0 ? data.userinfo.headUrl : '/app/' + data.userinfo.headUrl,
      focusIndustryList: setFocusIndustryList(data.userinfo.focusIndustryList),
      focusCategoryList: setFocusCategoryList(data.userinfo.focusCategoryList)
    })
    this.commit('CHANGE_USER_INFO', Object.assign({}, data.userinfo, Object.assign({}, state.userinfo, data.userinfo, headUrl)))
  },
  [GET_VIP_INFORMATION] (state, data) {
    // let lastDays = moment(data.vipinfo.endTime, 'YYYY-MM-DD').dayOfYear() - moment().dayOfYear()
    if (data.vipinfo.code === 503 && data.vipinfo.success === false) {
      // 非VIP
    } else {
      // 购买成功后给用户设置为VIP
      state.roleId = 1
      console.log(data.vipinfo.data)
      localStorage.setItem('access_roleId', 1)
      state.vipinfo = Object.assign({}, state.vipinfo, data.vipinfo.data, {
        lastDays: data.vipinfo.residueDays,
        lastLoginTime: moment(state.vipinfo.cTime).format('YYYY-MM-DD HH:mm')
      })
    }
  },
  [UPDATE_USER_AVATAR] (state, data) {
    console.log(data)
    state.headUrl = data.url.indexOf('http') === 0 ? data.url : '/app/' + data.url
    state.userinfo.headUrl = data.url.indexOf('http') === 0 ? data.url : '/app/' + data.url
    localStorage.setItem('access_img', state.headUrl)
  },
  [UNBIND_WECHAT] (state) {
    state.userinfo = Object.assign({}, state.userinfo, {
      wechat: '--'
    })
  },
  [GET_MY_INVOICE] (state, data) { // 获取发票历史
    state.invoice.pages = Object.assign({}, state.invoice.pages, data.pages)
    state.invoice.params = Object.assign({}, state.invoice.params, data.params)
    state.invoice.list = data.list
  },
  [SUBMIT_AN_INVOICE] (state, data) {

  },
  [UPDATE_COMPARE_IDS] (state, data) {
    state.compareIds = data.map(d => {
      return d
    })
  },
  [CLEAR_USER_LOGGED] (state) {
    state.token = ''
  },
  [UPDATE_WECHAT_DATA] (state, data) {
    state.userinfo.wechat = data
  }
}
const getters = {
  logged: state => !!state.token,
  vipServices: state => {
    let rate = `${state.vipinfo.currentMonthLimit}/${state.vipinfo.seeLimit}`
    let value = state.vipinfo.seeLimit - state.vipinfo.currentMonthLimit
    if (state.vipinfo.annual) {
      rate = '无限制'
      value = state.vipinfo.seeLimit
    }
    return {
      monthService: {
        name: 'monthService',
        color: '#458CC8',
        max: state.vipinfo.seeLimit,
        value: value,
        rate: rate
      },
      vipService: {
        name: 'vipService',
        color: '#458CC8',
        max: state.vipinfo.reportLimit,
        value: state.vipinfo.reportLimit - state.vipinfo.reportUse,
        rate: `${state.vipinfo.reportUse}/${state.vipinfo.reportLimit}`
      },
      weiboService: {
        name: 'weiboService',
        color: '#458CC8',
        max: state.vipinfo.weiboLimit,
        value: state.vipinfo.weiboLimit - state.vipinfo.weiboUse,
        rate: `${state.vipinfo.weiboUse}/${state.vipinfo.weiboLimit}`
      }

    }
  },
  isVip: state => {
    return state.userinfo.isVip
  },
  levelName: state => {
    return state.userinfo.role
    // 0'免费版', 1'个人专业版', 2('企业专业版','内部员工'),3'试用版'
  },
  levelId: state => {
    return state.userinfo.roleId
  },
  isAnnualFeeVip: state => {
    return !_.isEmpty(state.vipinfo) && state.vipinfo.annual === 1
  },
  // 根据权限，限制选择【关注行业】【关注风险】的数量
  userLimit (state) {
    // 关注行业：普通用户0个；个人专业版3个；企业专业版无限；3试用版1个
    const industryMap = [0, 3, null, 1]
    // 关注风险：普通用户0个；个人专业版5个；企业专业版无限；3试用版3个
    const categoryMap = [0, 5, null, 3]
    return {
      industry: industryMap[state.userinfo.roleId || 0],
      category: categoryMap[state.userinfo.roleId || 0]
    }
  },
  compareIds: state => state.compareIds,
  roleId: state => state.userinfo.roleId
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/pages/index/store/modules/user.js